/**
 * Secciones del PDF del F22 AT 2026 del empresario individual para la parte persona: la
 * base imponible del IGC (líneas 1 a 24) y el Impuesto Global Complementario (líneas 25 a
 * 53). Común a todos los regímenes del AT 2026: cada módulo las agrega a su documento con
 * el numeral que le corresponda. Usa las mismas fórmulas de la pantalla (calcularPersona)
 * y las piezas comunes de los PDF de renta (F22/common/pdfComun.js).
 */
const { fmt, fieldRow, subsectionHtml, sectionHtml } = require('../../../F22/common/pdfComun');
const { calcularPersona } = require('./formulas');

const ANIO_COMERCIAL = 2025;

const buildBaseImponibleIGC = (data, numeral) => {
  const c = calcularPersona(data);
  const linea1 = subsectionHtml('Línea 1 · Retiros afectos al IGC (art. 14 letras A) y D) N° 3 LIR)', [
    fieldRow('', '2005', 'a) Propios · crédito con restitución, sin devolución', fmt(c[2005])),
    fieldRow('', '2006', 'a) Propios · crédito con restitución, con devolución', fmt(c[2006])),
    fieldRow('', '2007', 'a) Propios · crédito sin restitución, sin devolución', fmt(c[2007])),
    fieldRow('', '2008', 'a) Propios · crédito sin restitución, con devolución', fmt(c[2008])),
    fieldRow('(+)', '2009', 'a) Propios · retiros', fmt(c[2009])),
    fieldRow('', '2000', 'b) Por participaciones · crédito con restitución, sin devolución', fmt(c[2000])),
    fieldRow('', '2001', 'b) Por participaciones · crédito con restitución, con devolución', fmt(c[2001])),
    fieldRow('', '2002', 'b) Por participaciones · crédito sin restitución, sin devolución', fmt(c[2002])),
    fieldRow('', '2003', 'b) Por participaciones · crédito sin restitución, con devolución', fmt(c[2003])),
    fieldRow('(+)', '2004', 'b) Por participaciones · retiros', fmt(c[2004])),
    fieldRow('(=)', '104', 'Total retiros afectos', fmt(c[104]), 'subtotal'),
  ]);
  const otras = subsectionHtml('Otras rentas', [
    fieldRow('(+)', '155', 'Línea 8 · Rentas de capitales mobiliarios', fmt(c[155])),
    fieldRow('(+)', '152', 'Línea 9 · Rentas exentas del IGC', fmt(c[152])),
    fieldRow('(+)', '161', 'Línea 13 · Sueldos, pensiones y sueldo empresarial', fmt(c[161])),
    fieldRow('', '159', 'Línea 14 · Incremento por IDPC', fmt(c[159])),
    fieldRow('', '748', 'Línea 14 · Incremento por impuestos soportados en el exterior', fmt(c[748])),
    fieldRow('(+)', '749', 'Línea 14 · Total incrementos', fmt(c[749])),
    fieldRow('(-)', '169', 'Línea 17 · Pérdida en operaciones de capitales mobiliarios', fmt(c[169])),
  ]);
  const base = subsectionHtml('Base imponible', [
    fieldRow('(=)', '158', 'Línea 19 · Subtotal', fmt(c[158]), 'subtotal'),
    fieldRow('(=)', '170', 'Línea 24 · Base imponible anual del IGC', fmt(c[170]), 'total'),
  ]);
  return sectionHtml(
    numeral,
    'Base imponible del Impuesto Global Complementario',
    `Rentas del titular del año comercial ${ANIO_COMERCIAL} — líneas 1 a 24 del Formulario 22`,
    `${linea1}${otras}${base}`
  );
};

const buildImpuestoGlobalComplementario = (data, numeral) => {
  const c = calcularPersona(data);
  const impuesto = subsectionHtml('Impuesto', [
    fieldRow('(+)', '157', 'Línea 25 · IGC según tabla', fmt(c[157])),
    fieldRow('(+)', '1035', 'Línea 29 · Débito fiscal por restitución del crédito por IDPC', fmt(c[1035])),
  ]);
  const sinDevolucion = subsectionHtml('Créditos sin derecho a devolución', [
    fieldRow('(-)', '136', 'Línea 34 · Crédito proporcional por rentas exentas', fmt(c[136])),
    fieldRow('(-)', '176', 'Línea 35 · Crédito por impuesto tasa adicional', fmt(c[176])),
    fieldRow('(-)', '608', 'Línea 37 · Crédito por IDPC sin derecho a devolución', fmt(c[608])),
    fieldRow('(-)', '895', 'Línea 41 · Crédito por gastos en educación', fmt(c[895])),
    fieldRow('(-)', '746', 'Línea 49 · Crédito por impuestos soportados en el exterior', fmt(c[746])),
  ]);
  const conDevolucion = subsectionHtml('Créditos con derecho a devolución', [
    fieldRow('(-)', '162', 'Línea 46 · Crédito por impuesto único de segunda categoría', fmt(c[162])),
    fieldRow('(-)', '610', 'Línea 48 · Crédito por IDPC con derecho a devolución', fmt(c[610])),
  ]);
  const resultado = subsectionHtml('Resultado del IGC', [
    fieldRow('(=)', '304', 'Línea 52 · IGC determinado', fmt(c[304]), 'subtotal'),
    fieldRow('(=)', '31', 'Línea 53 · IGC a declarar', fmt(c[31]), 'total'),
    fieldRow('', '119', 'Línea 97 · Remanente de crédito del impuesto único (devolvible)', fmt(c[119])),
    fieldRow('', '116', 'Línea 97 · Remanente de crédito por IDPC (devolvible)', fmt(c[116])),
  ]);
  return sectionHtml(
    numeral,
    'Impuesto Global Complementario',
    'Impuesto del titular, créditos y remanentes — líneas 25 a 53 del Formulario 22',
    `${impuesto}${sinDevolucion}${conDevolucion}${resultado}`
  );
};

module.exports = { buildBaseImponibleIGC, buildImpuestoGlobalComplementario };
